/**
 * https://v15.vuetifyjs.com/en/framework/typography
 */
import _ from 'underscore'

const allowedColors = [
    'dark',
    'primary',
    'secondary',
    'accent',
    'light',
    'error',
    'info',
    'success',
    'warning',
    'white',
    ''
]

const allowedFontSizes = [
    'display-4',
    'display-3',
    'display-2',
    'display-1',
    'headline',
    'title',
    'subheading',
    'body-2',
    'body-1',
    'caption'
]

const allowedFontWeights = [
    'thin',
    'light',
    'regular',
    'medium',
    'bold',
    'black'
]

const allowedTransforms = [
    'capitalize',
    'lowercase',
    'none',
    'uppercase'
]

/**
 * @mixin
 */
export default {
    props: {
        /**
         * Font Color
         * dark
         * primary
         * secondary
         * accent
         * light
         * error
         * info
         * success
         * warning
         * white
         * ''
         */
        color: {
            type: String,
            default: '',
            validator: (item) => _.contains(allowedColors, item)
        },
        /**
         * Font Size
         * display-4 - Good for `<h1>`
         * display-3 - Good for `<h2>`
         * display-2 - Good for `<h3>`
         * display-1 - Good for `<h4>`
         * headline - Good for `<h5>`
         * title - Good for `<h6>`
         * subheading - Good for supporting text
         * body-2 - Regular body text with additional weight
         * body-1 - Regular body text
         * caption - Smaller size text
         */
        fontSize: {
            type: String,
            default: 'body-1',
            validator: (item) => _.contains(allowedFontSizes, item)
        },
        /**
         * Font Weight
         * thin - Sets font-weight to 100
         * light - Sets font-weight to 300
         * regular - Sets font-weight to 400
         * medium - Sets font-weight to 500
         * bold - Sets font-weight to 700
         * black - Sets font-weight to 900
         */
        fontWeight: {
            type: String,
            default: 'regular',
            validator: (item) => _.contains(allowedFontWeights, item)
        },
        /**
         * Text Transforms
         * capitalize - Sets text-transform to capitalize
         * lowercase - Sets text-transform to lowercase
         * none - Sets text-transform to none
         * uppercase - Sets text-transform to uppercase
         */
        transform: {
            type: String,
            default: 'none',
            validator: (item) => _.contains(allowedTransforms, item)
        },
        /**
         * Sets the font-style to italic
         */
        italic: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fontClass () {
            const vm = this
            return {
                [vm.fontSize]: true,
                [`font-weight-${vm.fontWeight}`]: true,
                [`text-${vm.transform}`]: true,
                'font-italic': vm.italic
            }
        },
        fontStyle () {
            return {
                color: this.$vuetify.theme[this.color]
            }
        }
    }
}
